import type { Product } from "~/types/ecom/product/product.type";

export const useCompareStore = defineStore(
  "product-compare",
  () => {
    const maxComparableProducts = ref({ desktop: 8, mobile: 8 });

    const checkedProduts = ref<Product[]>([]);
    const enableExpand = ref<boolean>(false);
    const isCompareRowVisible = ref<boolean>(false);
    const isSpecificationEnable = ref<boolean>(false);

    const addToCompareSearchQuery = ref("");
    const isDifferenceOnlyEnabled = ref(false);
    const freezedProductCode = ref<string>();
    const comparableProperties = ref<string[]>(["Technical specifications"]);
    const isFreezed = ref<boolean>(true);

    function toggleFreeze(productCode: string | undefined) {
      if (
        freezedProductCode.value &&
        freezedProductCode.value === productCode
      ) {
        freezedProductCode.value = undefined;
        return;
      }
      freezedProductCode.value = productCode;
    }

    function clearCompareProducts() {
      checkedProduts.value = [];
      isCompareRowVisible.value = false;
    }

    function removeCompareProduct(product: Product) {
      checkedProduts.value = checkedProduts.value.filter(
        (p) => p.code !== product.code
      );
      if (!checkedProduts.value.length) isCompareRowVisible.value = false;
    }

    return {
      maxComparableProducts,
      comparableProperties,
      addToCompareSearchQuery,
      isDifferenceOnlyEnabled,
      freezedProductCode,
      toggleFreeze,
      checkedProduts,
      clearCompareProducts,
      removeCompareProduct,
      enableExpand,
      isCompareRowVisible,
      isSpecificationEnable,
      isFreezed,
    };
  },
  {
    persist: {
      pick: ["checkedProduts"],
      storage: import.meta.client ? localStorage : undefined,
    },
  }
);

// Pinia hot reload
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCompareStore, import.meta.hot));
}
